module.exports = __webpack_public_path__ + "img/ai-gateway.6ff45e9e.svg";